/* @flow */
import apiRequest from 'lib/apiRequest';
import UserActions from 'user/UserActions';
import GroupActions from 'groups/actions/GroupActions';

const TIMEOUT = 30000; // 30 seconds

// polls until the rostering job is done,
// or it times out.
// then refreshes user and group stores.
export async function pollAndRefresh(endpoint: string) {
  try {
    await pollRosterEndpoint(endpoint);
  } catch (e) {
    console.error('SetupRosterPoll failed to poll rostering endpoint');
  }

  try {
    await UserActions.loadCurrentUser();
  } catch (e) {
    console.error('SetupRosterPoll failed to refresh user');
  }

  try {
    await GroupActions.loadGroups();
  } catch (e) {
    console.error('SetupRosterPoll failed to refresh groups');
  }
}

export function pollRosterEndpoint(endpoint: string): Promise<void> {
  return new Promise((resolve, reject) => {
    let currentTimeout;
    const poll = function() {
      apiRequest(endpoint)
        .then(response => {
          if (response.status === 'pending') {
            currentTimeout = setTimeout(poll, 1000);
          } else {
            resolve();
          }
        })
        .catch(err => {
          reject(err);
        });
    };

    poll();
    setTimeout(() => {
      clearTimeout(currentTimeout);
      reject({ message: 'Poll query timed out' });
    }, TIMEOUT);
  });
}
